module.exports = __webpack_public_path__ + "7b9fcd93882393aaa16043a04c4a3bb4.svg";